import { routes as nestedRoutes } from './:id'

export const routes = {
  ...nestedRoutes,
}
